import {useCallback, useRef, MutableRefObject} from 'react';

export const useTextMeasurement = () => {
    const canvas = useRef<HTMLCanvasElement>();
    const context = useRef<CanvasRenderingContext2D>();

    const measureText = useCallback((text: string, font: string) => {
        if (!canvas.current) {
            canvas.current = document.createElement('canvas');
        }

        if (!context.current) {
            const canvasContext = canvas.current.getContext('2d');

            if (canvasContext) {
                context.current = canvasContext;
            }
        }

        if (context.current) {
            context.current.font = font;
            return context.current.measureText(text).width;
        }

        return 0;
    }, []);

    const getLines = useCallback(
        (
            containerWidth: number,
            textContainer: MutableRefObject<HTMLDivElement>,
            text?: string
        ) => {
            if (text) {
                const style = getComputedStyle(textContainer.current);

                const lines: string[] = [];
                let words: string[] = [];

                let lineWidth = 0;
                const spaceWidth = measureText(' ', style.font);

                text.split(' ').forEach((word) => {
                    const wordWidth = measureText(word, style.font);
                    const spaceWidthCheck = lineWidth == 0 ? 0 : spaceWidth;

                    if (
                        lineWidth + wordWidth + spaceWidthCheck <
                        containerWidth
                    ) {
                        words.push(word);
                        lineWidth += wordWidth + spaceWidthCheck;
                    } else {
                        lines.push(words.join(' '));
                        words = [word];
                        lineWidth = wordWidth;
                    }
                });

                if (words.length > 0) {
                    lines.push(words.join(' '));
                }

                return lines;
            }
            return [];
        },
        []
    );

    return {measureText, getLines};
};
